export default "__VITE_ASSET__19edd30c__"